import { useEffect } from "react";

export const useScrollToTop = () => {
  window.scrollTo(0, 0);
};
